import type { ScenarioRowProps } from "./scenario-row-types";
import { ScenarioVariantInline } from "./scenario-variant-inline";
import { ScenarioVariantPill } from "./scenario-variant-pill";
import { ScenarioVariantCompact } from "./scenario-variant-compact";
import { ScenarioVariantFull } from "./scenario-variant-full";

/**
 * ScenarioRow (aliased as ScenarioItem) — canonical visual representation of a scenario.
 * Supports 4 variants: "full", "compact", "pill", and "inline".
 */
export function ScenarioRow({
  scenario,
  variant = "full",
  href,
  onSelect,
  projectId,
  actions,
  trailing,
  leading,
  badge,
  subtitle,
  headingLevel = "h3",
  className,
}: ScenarioRowProps) {
  const effectiveHref =
    href ??
    (projectId ? `/projects/${projectId}/scenarios/${scenario.id}` : null);

  if (variant === "inline") {
    return (
      <ScenarioVariantInline
        scenario={scenario}
        effectiveHref={effectiveHref}
        onSelect={onSelect}
        badge={badge}
        className={className}
      />
    );
  }

  if (variant === "pill") {
    return (
      <ScenarioVariantPill
        scenario={scenario}
        effectiveHref={effectiveHref}
        onSelect={onSelect}
        badge={badge}
        trailing={trailing}
        className={className}
      />
    );
  }

  if (variant === "compact") {
    return (
      <ScenarioVariantCompact
        scenario={scenario}
        effectiveHref={effectiveHref}
        onSelect={onSelect}
        actions={actions}
        trailing={trailing}
        leading={leading}
        badge={badge}
        subtitle={subtitle}
        headingLevel={headingLevel}
        className={className}
      />
    );
  }

  return (
    <ScenarioVariantFull
      scenario={scenario}
      effectiveHref={effectiveHref}
      onSelect={onSelect}
      projectId={projectId}
      actions={actions}
      subtitle={subtitle}
      headingLevel={headingLevel}
      className={className}
    />
  );
}

// Canonical alias
export { ScenarioRow as ScenarioItem };
